import { TbAlertTriangle, TbChevronDown } from "solid-icons/tb";
import { createUniqueId, type JSX, type ParentComponent, Show, Switch, Match } from "solid-js";

// Expansion is the parent's so a section can be opened from outside it: a deep
// link, a banner action, or state that only arrives with a fetch.
export const SettingsDisclosure: ParentComponent<{
  icon: JSX.Element;
  title: string;
  status?: JSX.Element;
  open: boolean;
  onToggle: () => void;
}> = (props) => {
  const bodyId = createUniqueId();

  return (
    <div class="overflow-hidden rounded-xl border border-primary-border">
      <button
        type="button"
        onClick={props.onToggle}
        class="flex w-full items-center gap-4 bg-panel p-5 text-left transition-colors hover:bg-tile"
        aria-expanded={props.open}
        aria-controls={bodyId}
      >
        <span class="flex size-10 shrink-0 items-center justify-center rounded-lg border border-muted-border bg-tile">
          {props.icon}
        </span>
        <span class="min-w-0 flex-1 text-base font-medium text-primary-text">{props.title}</span>
        {props.status}
        <TbChevronDown
          class={`size-4 shrink-0 text-muted-text transition-transform ${props.open ? "rotate-180" : ""}`}
        />
      </button>

      <Show when={props.open}>
        <div id={bodyId} class="flex flex-col gap-4 border-t border-primary-border p-5">
          {props.children}
        </div>
      </Show>
    </div>
  );
};

export const StatusBadge: ParentComponent<{ tone: "positive" | "warning" | "neutral" }> = (props) => (
  <Switch>
    <Match when={props.tone === "warning"}>
      <span class="inline-flex shrink-0 items-center gap-1.5 text-xs font-medium text-amber-700 dark:text-amber-400">
        <TbAlertTriangle class="size-3.5" aria-hidden />
        {props.children}
      </span>
    </Match>
    <Match when={props.tone === "positive"}>
      <span class="inline-flex shrink-0 items-center gap-1.5 text-xs font-medium text-primary-text">
        <span class="size-1.5 rounded-full bg-emerald-500" aria-hidden="true" />
        {props.children}
      </span>
    </Match>
    <Match when={props.tone === "neutral"}>
      <span class="shrink-0 text-xs text-muted-text">{props.children}</span>
    </Match>
  </Switch>
);
